// extracted by mini-css-extract-plugin
export default {"component":"TransferToOfficeModal_component__zLkLR","modalContainer":"TransferToOfficeModal_modalContainer__Bz2ne","input":"TransferToOfficeModal_input__9c7rg"};